require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./courses-code-101-intro-to-software-development-and-careers-in-tech.json") })
        }
      }, "path---courses-code-101-intro-to-software-development-and-careers-in-tech");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---courses-code-101-intro-to-software-development-and-careers-in-tech!./.cache/json/courses-code-101-intro-to-software-development-and-careers-in-tech.json
// module id = 1130
// module chunks = 231608221292675